import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import { getDateShort, getShortFormTimeFormat, getTime } from '@utils/dates';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import Notify from 'aquilla/icons/actions/Notify';
import Notified from 'aquilla/icons/misc/Notified';
import { StyleProvider } from 'aquilla/styled/StyleProvider';
import { differenceInDays, differenceInSeconds } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';

const UpcomingInfoWrapper = styled.div`
  position: absolute;
  display: flex;
  z-index: 1;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  border-radius: 0px 0px ${Spacings.SPACING_2B} ${Spacings.SPACING_2B};
  align-items: center;
  justify-content: space-between;
  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
  }
`;

const Timer = styled(Typography)`
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.H5};
  }
`;

const ScheduledTime = styled(Typography)`
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.H6};
  }
`;

const NotifyButton = styled(Button)`
  min-width: 200px;
  font-size: ${Fonts.H6};
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const UpcomingInfo = styled.div``;

const NotifyMe = ({
  classInfo,
  isUpcoming,
  setIsUpcoming,
  onNotify,
  isEnrolled = false,
  isClassHappenedAndNotRecorded
}) => {
  const styledConfig = {
    mode: isEnrolled ? 'dark' : 'light'
  };
  const [formattedTime, setTime] = useState(null);
  const timer = useRef(null);
  const start = useRef(new Date(classInfo.liveAt));
  useEffect(() => {
    if (isUpcoming) {
      let remainingTime = differenceInDays(start.current, new Date());
      if (remainingTime >= 1) {
        remainingTime += `${remainingTime === 1 ? ' day' : ' days'}`;
        setTime(remainingTime);
      } else {
        alert.current = true;
        timer.current = setInterval(() => {
          remainingTime = differenceInSeconds(start.current, new Date());
          if (remainingTime < 0) {
            clearInterval(timer.current);
            timer.current = null;
            setIsUpcoming(false);
          }
          remainingTime = getShortFormTimeFormat(remainingTime, ':');
          setTime(() => remainingTime);
        }, 1000);
      }
    }

    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, [isUpcoming, setIsUpcoming]);

  const renderBanner = (title, scheduleTime, notifyButtonText) => {
    return (
      <UpcomingInfoWrapper>
        <UpcomingInfo>
          <Timer variant="h4" color="var(--color-i-gray-9)">
            {title}
          </Timer>
          {scheduleTime ? (
            <ScheduledTime variant="p1" color="var(--color-text-secondary)">
              {scheduleTime}
            </ScheduledTime>
          ) : (
            ''
          )}
        </UpcomingInfo>
        {notifyButtonText ? (
          <StyleProvider config={styledConfig}>
            <NotifyButton
              startIcon={
                isEnrolled ? (
                  <Notified color="var(--color-i-icon-dark-secondary)" />
                ) : (
                  <Notify />
                )
              }
              variant="secondary"
              onClick={onNotify}
              disabled={isEnrolled}
            >
              {notifyButtonText}
            </NotifyButton>
          </StyleProvider>
        ) : (
          ''
        )}
      </UpcomingInfoWrapper>
    );
  };
  if (isClassHappenedAndNotRecorded) {
    return renderBanner('Recording will be available soon');
  }
  if (!isUpcoming) return null;

  return renderBanner(
    `This class will be live in ${formattedTime || ''}`,
    `${getDateShort(classInfo.liveAt)} at ${getTime(classInfo.liveAt)}`,
    isEnrolled ? "We'll notify you when the class is live" : 'Notify me'
  );
};

export default NotifyMe;
